import React, { useEffect, useState, useRef } from 'react'

import {
    Link,
    useNavigate
} from 'react-router-dom';

import { useSelector, useDispatch } from "react-redux";
import { setAuth } from '../actions';

import secureLocalStorage from "react-secure-storage";

import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';

import Modal from 'react-bootstrap/Modal';

import Card from 'react-bootstrap/Card';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image'
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';

import { priceFormat } from '../utils';
import { fetchRequest } from '../fetchRequest';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import DTable from '../DataTable/DTable'

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const Dashboard = ({ }) => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const containerLoaded = useRef(false);

    const { currentUser } = useSelector((state) => state.auth);

    const [date, setDate] = useState('');
    const [printReceipt, setPrintReceipt] = useState(true);
    const [detailCount, setDetailCount] = useState(0);

    const [posModal, setPosModal] = useState(false);
    const [tmpPosPort, setTmpPosPort] = useState('');
    const [tmpPosTerminal, setTmpPosTerminal] = useState('');

    const [detailPage, setDetailPage] = useState(1);
    const [detailPageSize, setDetailPageSize] = useState(10);
    const [detailSearchValue, setDetailSearchValue] = useState('');
    const [detailSortKey, setDetailSortKey] = useState('');
    const [detailSortOrder, setDetailSortOrder] = useState('');
    const [details, setDetails] = useState([]);

    const [labels, setLabels] = useState([]);
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [{
            label: 'Ашигласан',
            data: [],
            backgroundColor: []
        }]
    });

    const [productTotalCount, setProductTotalCount] = useState(0);
    const [productPage, setProductPage] = useState(1);
    const [productPageSize, setProductPageSize] = useState(10);
    const [productSearchValue, setProductSearchValue] = useState('');
    const [productSortKey, setProductSortKey] = useState('');
    const [productSortOrder, setProductSortOrder] = useState('');
    const [products, setProducts] = useState([]);

    const [receiptId, setReceiptId] = useState(null)
    const [receiptPassword, setReceiptPassword] = useState('')
    const [receiptModal, setReceiptModal] = useState(false)

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!containerLoaded?.current) {
            containerLoaded.current = true;
            loadDashboard(currentUser?.school);
            loadDashboardList(currentUser?.school, 'PRODUCT');
            loadDashboardList(currentUser?.school, 'DETAIL');
        }
    }, []);

    const CustomProfile = React.forwardRef(({ children, onClick }, ref) => (
        <a
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <Image
                className="icon-profile"
                src={`/assets/images/ic_profile.png`} />
        </a>
    ));


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: null,
            title: null,
        },
        scales: {
            y: {
                title: {
                    display: true,
                    text: 'Ашигласан тоо'
                },
                min: 0,
                ticks: {
                    stepSize: 10
                }
            }
        }
    };

    const productsConfig = {
        columnButton: false,
        showPagination: false,
        showFilter: true,
        footer: false,
        footerStyle: {
            backgroundColor: '#ebecf5',
            fontWeight: 'PinnacleBold',
            fontSize: '15px'
        }
    };

    const detailConfig = {
        columnButton: false,
        showPagination: true,
        showFilter: true,
        footer: false
    };

    const productsColumn = [
        {
            dataField: 'code',
            text: 'Код',
            sort: true,
            footer: '',
            style: { verticalAlign: 'middle' },
        },
        {
            dataField: 'name',
            text: "Нэр",
            sort: true,
            footer: '',
            style: { verticalAlign: 'middle' },
        },
        {
            dataField: 'totalQuantity',
            text: "Тоо",
            sort: true,
            footer: '',
            style: { verticalAlign: 'middle' },
            footerAlign: 'right',
            footerType: 'sum',
        },
    ];

    const detailColumn = [
        {
            dataField: 'createdDate.date',
            text: "Бүртгэсэн",
            sort: true,
            style: { verticalAlign: 'middle' },
            formatter: (cell) => cell?.slice(0, 19)
        },
        {
            dataField: 'typeName',
            text: "Төрөл",
            sort: true,
            style: { verticalAlign: 'middle' },
        },
        {
            dataField: 'className',
            text: "Анги",
            sort: true,
            style: { verticalAlign: 'middle' },
        },
        {
            dataField: 'code',
            text: "Хэрэглэгч",
            sort: true,
            style: { verticalAlign: 'middle' },
            formatter: (cell, row) => {
                return row?.code + ' ' + row?.firstName
            },
        },
        {
            dataField: '',
            text: "Талон",
            sort: false,
            style: { verticalAlign: 'middle' },
            formatter: (cell, row) => {
                return <Button type={'button'} variant="secondary" style={{ padding: 5 }} onClick={() => {
                    setReceiptId(row?.id)
                    setReceiptModal(true)
                }}>
                    Талон хэвлэх
                </Button>
            },
        },
    ];

    const loadDashboard = (schoolId = null) => {
        setLoading(true);
        fetchRequest("app/kiosk/dashboard", 'POST', {
            school: schoolId
        })
            .then(res => {
                const { itemTypes = [] } = res
                setLoading(false);
                if (res?.success) {
                    if (itemTypes && itemTypes.length > 0) {
                        let chartLabels = [];
                        let chartDataset = [];
                        let chartColors = [];

                        let obj = {};

                        for (let i = 0; i < itemTypes.length; i++) {
                            chartLabels.push(itemTypes[i]?.name);
                            chartDataset.push(itemTypes[i]?.detailCount);
                            chartColors.push(itemTypes[i]?.color || '#f00');
                        }
                        setLabels(chartLabels)

                        obj = {
                            labels: chartLabels,
                            datasets: [{
                                label: 'Ашигласан',
                                data: chartDataset,
                                backgroundColor: chartColors
                            }]
                        };
                        setDate(res?.today);
                        setChartData(obj);

                    }
                } else {
                    toast.warning(res?.message || 'Мэдээлэл дуудахад алдаа гарлаа', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                }
            }).catch(e => {
                setLoading(false);

                toast.warning('Хүсэлт илгээхэд алдаа гарлаа', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                })
            })
    }

    const loadDashboardList = (schoolId = null, pageType = null, page = 1, pageSize = 10, query = null, sortBy = null, order = 'DESC') => {
        setLoading(true);
        fetchRequest("app/kiosk/dashboard-list", 'POST', {
            school: schoolId,
            pageType,
            page,
            pageSize,
            query,
            sortBy,
            order
        })
            .then(res => {
                setLoading(false);
                if (res?.success) {

                    if (pageType == 'PRODUCT') {
                        setProductTotalCount(res?.totalCount);
                        setProducts(res?.list);
                    } else if (pageType == 'DETAIL') {
                        setDetailCount(res?.totalCount);
                        setDetails(res?.list);
                    }
                } else {
                    toast.warning(res?.message || 'Мэдээлэл дуудахад алдаа гарлаа', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                }
            }).catch(e => {
                setLoading(false);

                toast.warning('Хүсэлт илгээхэд алдаа гарлаа', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                })
            })
    }

    const productInteraction = (obj) => {
        setProductPageSize(obj.pageSize)
        setProductPage(obj.page)
        setProductSearchValue(obj.search)
        setProductSortKey(obj.sort)
        setProductSortOrder(obj.order)

        loadDashboardList(currentUser?.school, 'PRODUCT', obj?.page, obj?.pageSize, obj?.search, obj?.sort, obj?.order)
    }

    const detailInteraction = (obj) => {
        setDetailPageSize(obj.pageSize)
        setDetailPage(obj.page)
        setDetailSearchValue(obj.search)
        setDetailSortKey(obj.sort)
        setDetailSortOrder(obj.order)

        loadDashboardList(currentUser?.school, 'DETAIL', obj?.page, obj?.pageSize, obj?.search, obj?.sort, obj?.order)
    }

    const loadPosData = () => {
        setTmpPosPort(secureLocalStorage.getItem("eKioskPosPort"));
        setTmpPosTerminal(secureLocalStorage.getItem("eKioskPosTerminal"));

        setPosModal(true);
    }

    const updatePosData = () => {
        secureLocalStorage.setItem("eKioskPosPort", tmpPosPort);
        secureLocalStorage.setItem("eKioskPosTerminal", tmpPosTerminal);

        toast.success('ПОС тохиргоо хадгалагдлаа', {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false
        })

        setPosModal(false)
    }

    const print = () => {
        if (receiptId && receiptPassword) {
            setLoading(true);
            fetchRequest("app/kiosk/sale/print-receipt", 'POST', {
                school: currentUser?.school,
                detail: receiptId,
                password: receiptPassword
            })
                .then(res => {
                    setLoading(false);
                    if (res?.success) {
                        if (currentUser?.receipt) {
                            submitPrint(res?.sale, res?.user, res?.fontSize);
                        }

                        setReceiptId(null)
                        setReceiptPassword('')
                        setReceiptModal(false)
                    } else {
                        toast.warning(res?.message || 'Алдаатай хүсэлт', {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        })
                    }
                    console.log('Res', res)
                }).catch(e => {
                    setLoading(false);
                    toast.warning('Хүсэлт илгээхэд алдаа гарлаа', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                    
                })
        }
    }

    const submitPrint = (saleObj = {}, userObj = {}, fontSize = 10) => {

        let style = '<style>';
        style = style + '.schoolLogo {width:30%; height:20%}';
        style = style + '.logoLine{display:flex}';
        style = style + '.dateLogoContainer{margin-left:5%}';
        style = style + '.rowContainer{display:flex; width: 100%;}';
        style = style + '.row-class{width: 20%; padding: 0.5em 1em;}';
        style = style + '.row-studentcode{width: 30%; padding: 0.5em 1em;}';
        style =
            style +
            '.row-studentname{width: 40%; padding: 0.5em 1em; flex-wrap: wrap; word-wrap: break-word;}';
        style = style + '.row-food{width:30%; padding: 0.5em 1em}';
        style = style + '.row-foodNumber{width:20%; padding: 0.5em 1em}';
        style = style + '.row-foodPrice{width:20%; padding: 0.5em 1em}';
        style = style + '.row-foodTotal{width:30%; padding: 0.5em 1em}';
        style =
            style + '.row-total{width:40%; padding: 0.5em 1em;font-weight: bold;}';
        style =
            style +
            '.row-totalNumber{width:30%; padding: 0.5em 1em;font-weight: bold;}';
        style =
            style +
            '.row-totalPrice{display:flex;justify-content: flex-end;font-weight: bold;padding: 0.5em 1em}';
        style = style + '@media print { @page { margin: 0; } body { margin: 0cm; }}';
        style = style + '</style>';

        var win = window.open('', '_blank');
        win.document.write('<html style="margin: 0; padding: 0;"><head>');
        win.document.write(style);
        win.document.write('</head>');
        win.document.write('<body style="margin:0px;">');
        win.document.write('<div style="display:flex; margin:0px;">');
        win.document.write(
            `<div style="font-size:${fontSize}px; word-break: break-all; text-transform: uppercase;">` +
            currentUser?.schoolName +
            '</div>'
        );
        win.document.write('</div>');

        win.document.write(`<p style="margin: 0 0 10px; font-size: ${fontSize}px;">${userObj?.title ? userObj?.title + ',' : ''} ${userObj?.code ? userObj?.code + ',' : ''} ${userObj?.firstName}</p>`);

        win.document.write('<div style="margin:0px">');
        win.document.write(
            `<p style="width:40%;margin:0px;font-size:${fontSize}px;  display:inline-block; font-family:Roboto;">` +
            saleObj?.type +
            '</p>'
        );
        win.document.write(
            `<p style="width:20%;margin:0px;display:inline-block;font-size:${fontSize}px;font-family:Roboto;">` +
            1 +
            '</p>'
        );
        win.document.write(
            `<p style="width:20%;margin:0px; display:inline-block;font-size:${fontSize}px;font-family:Roboto;">` +
            priceFormat(saleObj?.price) +
            '</p>'
        );
        win.document.write(
            `<p style="display:inline-block;margin:0px; position:absolute; right:1em;font-size:${fontSize}px;font-family:Roboto;">` +
            priceFormat(saleObj?.price) +
            '</p>'
        );
        win.document.write('</div>');

        win.document.write('<div>');
        // win.document.write(
        //     '<p style="display:flex;font-size:8px;margin:0px; justify-content: center; margin-top: 10px;">' +
        //     'NOMCH IT CONSULTING © 77890122' +
        //     '</p>'
        // );
        win.document.write(
            `<p style="display:flex;font-size:${fontSize}px;margin:0px; justify-content: center;">` +
            saleObj?.date +
            '</p>'
        );
        win.document.write('</div>');
        win.document.write('</body></html>');
        win.document.body.style.fontFamily = "Pinnacle, Arial, sans-serif";
        win.document.close();

        win.print();
        win.close();
    };

    return <>
        <Navbar bg="light" expand="lg" className='e-navbar'>
            <button onClick={() => {
                navigate(-1)
            }}
                className="btn-transparent"
            >
                <Image
                    className="icon-dashboard"
                    src={`/assets/images/ic_back.png`} />
            </button>
            <div style={{ flex: 1 }}>

            </div>
            <Dropdown
                align={{ lg: 'end' }}
                autoClose={false}
            >
                <Dropdown.Toggle as={CustomProfile} id="dropdown-custom-components">
                    {currentUser?.person?.firstName}
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ width: 250 }}>
                    <h4 className='p-10'>{currentUser?.person?.firstName}</h4>
                    <div style={{ padding: 10, width: '100%', cursor: 'pointer' }} onClick={() => {
                        window.location.reload();
                    }}>
                        <div style={{
                            width: 40,
                            display: 'inline-block',
                            textAlign: 'center'
                        }}>
                            <Image
                                className="icon-dropdown"
                                src={`/assets/images/ic_refresh.png`} />
                        </div>
                        Дахин ачааллах
                    </div>
                    <div style={{ padding: 10 }}>
                        <Form>
                            <Form.Check
                                type="switch"
                                id="receipt_switch"
                                label="Талон хэвлэх"
                                checked={printReceipt}
                                onChange={(e) => {
                                    setPrintReceipt(e.target.checked);
                                    dispatch(setAuth({ ...currentUser, ...{ receipt: e.target.checked } }));
                                }}
                            />
                        </Form>
                    </div>
                    {
                        currentUser?.golomtPos && <div style={{ padding: 10, width: '100%', cursor: 'pointer' }}
                            onClick={loadPosData}>
                            <div style={{
                                width: 40,
                                display: 'inline-block',
                                textAlign: 'center'
                            }}>
                                <Image
                                    style={{ height: 25 }}
                                    src={`/assets/images/pos.png`} />
                            </div>
                            POS тохиргоо
                        </div>
                    }
                    <hr />
                    <div style={{ padding: 10 }}>
                        <a href="/logout" style={{ textDecoration: 'none' }}>
                            <div style={{
                                width: 40,
                                display: 'inline-block',
                                textAlign: 'center'
                            }}>
                                <Image
                                    className="icon-dropdown"
                                    src={`/assets/images/ic_exit.png`} />
                            </div>
                            Гарах
                        </a>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </Navbar>
        <div className="dashboard-content-container">

            {
                loading && <>
                    <Spinner animation="border"
                        variant="warning"
                        size="lg" />
                </>
            }
            <Card className="portlet">
                <Card.Header className="portlet-header">{date}</Card.Header>
                <Card.Body>
                    <Bar
                        options={options}
                        data={chartData}
                        height={300}
                    />
                </Card.Body>
            </Card>

            <Card className="portlet">
                <Card.Body>
                    <DTable
                        remote
                        config={productsConfig}
                        columns={productsColumn}
                        data={products}
                        totalDataSize={productTotalCount}
                        onInteraction={productInteraction}
                    />
                </Card.Body>
            </Card>

            <Card className="portlet">
                <Card.Body>
                    <DTable
                        remote
                        config={detailConfig}
                        columns={detailColumn}
                        data={details}
                        totalDataSize={detailCount}
                        onInteraction={detailInteraction}
                    />
                </Card.Body>
            </Card>
        </div>

        <Modal
            show={posModal}
            centered
            backdrop="static"
            onHide={() => {
                setPosModal(false)
            }}>
            <Modal.Header>
                POS тохиргоо
            </Modal.Header>
            <Modal.Body>
                <Row className={'mt-20'}>
                    <label>Port No:</label>
                    <InputGroup className="mb-3">
                        <Form.Control aria-label="USB port number"
                            onChange={(e) => {
                                setTmpPosPort(e.target.value)
                            }}
                            value={tmpPosPort}
                            placeholder="USB port number" />
                    </InputGroup>
                </Row>
                <Row className={'mt-20'}>
                    <label>Terminal number:</label>
                    <InputGroup className="mb-3">
                        <Form.Control aria-label="Terminal number"
                            onChange={(e) => {
                                setTmpPosTerminal(e.target.value)
                            }}
                            value={tmpPosTerminal}
                            placeholder="Terminal number" />
                    </InputGroup>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ width: '100%' }}>
                    <Col className="text-center">
                        <Button className='btn-gray'
                            style={{
                                marginTop: 20,
                                marginRight: 20,
                                padding: '15px 50px'
                            }}
                            onClick={() => {
                                setPosModal(false)
                            }}>
                            Цуцлах
                        </Button>
                        <Button variant="" className='btn btn-main' onClick={updatePosData}>
                            Хадгалах
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>

        <Modal
            show={receiptModal}
            centered
            backdrop="static"
            onHide={() => {
                setReceiptId(null)
                setReceiptPassword('')
                setReceiptModal(false)
            }}>
            <Modal.Header>
                Талон дахин хэвлэх
            </Modal.Header>
            <Modal.Body>
                <Row className={'mt-20'}>
                    <label>Нууц үг:</label>
                    <InputGroup className="mb-3">
                        <Form.Control aria-label="password"
                            onChange={(e) => {
                                setReceiptPassword(e.target.value)
                            }}
                            autoComplete={false}
                            type={'password'}
                            value={receiptPassword}
                            placeholder="Нууц үг" />
                    </InputGroup>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ width: '100%' }}>
                    <Col className="text-center">
                        <Button variant="" className='btn btn-secondary' onClick={() => {
                            setReceiptId(null)
                            setReceiptPassword('')
                            setReceiptModal(false)
                        }}>
                            Цуцлах
                        </Button>
                        <Button variant="" className='btn btn-primary' style={{ marginLeft: 20 }} onClick={print}>
                            Хэвлэх
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </>
}
export default Dashboard;
